export const toggleDescriptions = (descriptionContainer) => {
    if (!descriptionContainer) return;
    console.log(descriptionContainer)

    const toggleText = descriptionContainer.querySelector(".description-toggle--inside");
    const toggleButton = descriptionContainer.querySelector("#toggleButton");
    const children = Array.from(toggleText.children);

    let initialHeight = 0;
    const buffer = 20; // Add buffer to ensure text is not cut off
    const maxHeightSingleP = 55; // Maximum height for a single <p>

    const paragraphs = children.filter((child) => child.tagName === "P");
    if (paragraphs.length === 1) {
        toggleText.style.height = maxHeightSingleP + "px";
    } else {
        if (children.length > 0 && children[0].tagName.startsWith("H")) {
            let firstPFound = false;
            for (let i = 0; i < children.length; i++) {
                if (i === 0 || (children[i].tagName === "P" && !firstPFound)) {
                    initialHeight += children[i].getBoundingClientRect().height;
                    if (children[i].tagName === "P") {
                        firstPFound = true;
                    }
                }
            }
        } else {
            if (children.length > 0) {
                initialHeight = children[0].getBoundingClientRect().height;
            }
        }

        toggleText.style.height = initialHeight + buffer + "px";
    }

    toggleText.style.overflow = "hidden";
    toggleText.style.transition = "height 0.5s ease";

    toggleButton.addEventListener("click", function () {
        if (toggleButton.textContent === "Więcej") {
            toggleText.style.height = toggleText.scrollHeight + "px";
            toggleButton.textContent = "Zwiń...";
            toggleButton.classList.add("open");
        } else {
            if (paragraphs.length === 1) {
                toggleText.style.height = maxHeightSingleP + "px";
            } else {
                toggleText.style.height = initialHeight + buffer + "px";
            }
            toggleButton.textContent = "Więcej";
            toggleButton.classList.remove("open");
        }
    });
};
